export default {"src":"/_next/static/media/0x350a791bfc2c21f9ed5d10980dad2e2638ffa7f6.bc433701.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};